<template>
  <v-btn color="primary"
         class="text-body-1 font-weight-bold"
         elevation="0"
         height="44"
         data-cy="atom-button">
    {{ title }}
    <template #append>
      <slot name="append"/>
    </template>

    <template #prepend>
      <slot name="prepend"/>
    </template>
  </v-btn>
</template>
<script setup lang="ts">
defineProps<{ title: string }>()
</script>
